import template from './advertExperienceList.html';
import controller from './advertExperienceList.controller';
import './advertExperienceList.scss';

let advertExperienceListComponent = {
  restrict: 'E',
  bindings: {
    adverts: '<',
    locations: '<',
    nonRacingEvents: '<',
    orderChanged: '&',
    changeState: '&'
  },
  template,
  controller
};

export default advertExperienceListComponent;
